import { render } from "./Library.vue?vue&type=template&id=4de07740"
const script = {}

import exportComponent from "/opt/boarddata/boarddata.io/django/templates/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__